

















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders, VAction } from '@/models/pagedlistmodel';
import { EpicorViewModel, Epicor } from '@/models/expense/epicor.attachment';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import {getHeaders } from '@/views/epicor/epicor';
import {attachmentTypeService,epicorAttachmentService,attachmentService} from '@/shared';

@Component({
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})

export default class EpicorAttachmentPage extends Base {
    public headers: VHeaders[] = getHeaders(this);
    public loading: boolean = false;
    public pagedAttachments: EpicorViewModel[] = [];
    public attachmentTypes: any = [];
    public paginations = new PaginationModel('attachmentName');
    public attachmentTypeToggle: boolean = false;
    public identifier: string = '';
    public identifierLabel: string = 'Deal Number';
    public types = [{ name: 'Deal' }, { name: 'Vehicle' }, { name: 'RO' }];
    public epicorModel: Epicor = {};

    public actions: VAction[] = [];

    public setActions() {
        this.actions = [{
            type: 'button',
            icon: 'fas fa-eye',
            title: this.$parent.$t('epicorAttachments.epicorGrid.gridActions.view') as string,
            loading: false,
            action: (model: EpicorViewModel, action: VAction) => {
                this.openAttachment(model.attachmentUri, action);
            },
        },
        {
            type: 'button',
            icon: 'fas fa-download',
            title: this.$parent.$t('epicorAttachments.epicorGrid.gridActions.download') as string,
            loading: false,
            action: (model: EpicorViewModel, action: VAction) => {
                this.downloadFile(model.attachmentUri, action);
            },
        },
        ];
    }

    public mounted() {
        this.setActions();
        this.getEpicorAttachments();
        this.getAttachmentTypes();
    }

    public async getEpicorAttachments(): Promise<void> {
        try {
            this.loading = true;
            const attachments = await epicorAttachmentService.getEpicorAttachments();
            this.pagedAttachments = attachments.results;
            this.paginations.totalItems = attachments.total;
        } finally {
            this.loading = false;
        }
    }

    public updatePaging(page: PaginationModel) {
        this.paginations = page;
    }

    public async getAttachmentTypes(): Promise<void> {
        const attachmentTypes = await attachmentTypeService.getAttachmentTypes();
        this.attachmentTypes = attachmentTypes.results;
    }

    public async openAttachment(uri: string, action: VAction): Promise<void> {
        if (!uri) {
            this.showAlert(false, this.$t('epicorAttachments.UriNotFound'));
            return;
        }

        try {
            action.loading = true;
            await attachmentService.viewAttachmentByUriAsync(uri);
        } finally {
            action.loading = false;
        }
    }
    public async downloadFile(attachmentUri: string, action: VAction): Promise<void> {
        try {
            action.loading = true;
            const attachment = await epicorAttachmentService.downloadAttachment(attachmentUri);
            const bytes = _file.base64ToArrayBuffer(attachment.fileContent);
            _file.downloadBytes(bytes, '', attachment.fileDownloadName);
        } finally {
            action.loading = false;
        }
    }

    public showEditDialog(attachmentUri: string): void {
        this.identifier = '';
        this.epicorModel = {};
        this.epicorModel.attachmentUri = attachmentUri;
        this.attachmentTypeToggle = false;
    }


    public typeChange(selectedType: string): void {
        this.epicorModel.identifierType = selectedType;
        this.identifier = '';
        switch (selectedType) {
            case 'Deal':
                this.identifierLabel = 'Deal Number';
                this.attachmentTypeToggle = false;
                break;
            case 'Vehicle':
                this.identifierLabel = 'VIN';
                this.attachmentTypeToggle = false;
                break;
            case 'RO':
                this.identifierLabel = 'RO Number';
                this.attachmentTypeToggle = true;
                break;
            default:
                this.identifierLabel = '';
        }
    }
}
